module.exports = __webpack_public_path__ + "static/larsseit-regular-df310f499a3a6006c6d8119802cc82eb.woff";